import VueCookies from "vue-cookies";
import { SupplierServices } from "@/services/nextshop/supplier.service";

export default {
  methods: {
    async getSuppliers() {
      try {
        const req = {
          merchantId: VueCookies.get('MID'),
          person: 2,
          query: "",
          sort: "date",
        };

        const response = await SupplierServices.getListSupplier(req)

        if (response.success) {
          return response.data
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}